// src/supabaseClient.js
// Configuración del cliente de Supabase

import { createClient } from '@supabase/supabase-js';

// Obtener variables de entorno
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validar que existan las variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ Faltan variables de entorno de Supabase');
  console.error('Asegúrate de crear un archivo .env.local con:');
  console.error('REACT_APP_SUPABASE_URL=tu-url');
  console.error('REACT_APP_SUPABASE_ANON_KEY=tu-key');
}

// Crear cliente de Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true, // Habilitar persistencia de sesión para auth
  },
});

// Función helper para verificar conexión
export const testConnection = async () => {
  try {
    const { data, error } = await supabase.from('properties').select('count');
    if (error) throw error;
    console.log('✅ Conexión a Supabase exitosa');
    return true;
  } catch (error) {
    console.error('❌ Error conectando a Supabase:', error.message);
    return false;
  }
};